import {createSelector} from 'reselect';

import backendService from '../../services/app/backendService';
import deviceTypesService from '../../services/device/deviceTypesService';
import productHelpers from '../../services/product/productHelpers';
import {makeSelectIotDeviceData} from './iotDevice';
import {makeSelectAssetByType} from './yapEncrypted';

const selectConsumer = (state) => state.consumer;

const makeSelectConsumerProducts = () => createSelector(selectConsumer, (state) => state.products);

const makeSelectConsumerData = () => createSelector(selectConsumer, (state) => state.data);

const makeSelectAggregatedSettings = () => createSelector(selectConsumer, (state) => state.aggregatedSettings);

const makeSelectConsumerProduct = (device) => {
    const {codentify, deviceSerialNumber, isP4} = device;

    return createSelector(makeSelectConsumerProducts(), (products) =>
        productHelpers.findProduct({
            products,
            isP4,
            deviceSerialNumber,
            codentify,
        })
    );
};

const makeSelectIotDeviceFullData = () =>
    createSelector(makeSelectIotDeviceData(), makeSelectAssetByType(), (iotDevice, gamProduct) => {
        if (iotDevice?.device) {
            const isGamBackend = backendService.isGamBackend();
            const device = {...iotDevice.device};
            let holder;
            const {isP4, isP1V4} = device;

            if (isGamBackend) {
                const {colorHex} = gamProduct || {};

                device.colorHex = colorHex;
            }

            if (iotDevice.holder) {
                holder = {...iotDevice.holder};

                holder.codentifyOriginal = holder.codentify;
            }

            const iotDeviceType = device?.type;

            device.nameKey = deviceTypesService.getProductNameKeyByType(iotDeviceType);
            device.isP4 = isP4;
            device.isP1V4 = isP1V4;

            return {...iotDevice, device, holder};
        } else {
            return iotDevice;
        }
    });

const selectDeviceNameKey = createSelector(makeSelectIotDeviceFullData(), (iotDevice) => iotDevice?.device?.nameKey);

const makeSelectConsumerTnc = () => createSelector(selectConsumer, (state) => state.tnc);

const makeSelectConsumerAcceptedTnc = () => createSelector(selectConsumer, (state) => state.acceptedTnc);

const makeSelectTncByType = (type) =>
    createSelector(makeSelectConsumerTnc(), (tnc) => tnc?.find((item) => item.screenId === type));

const makeSelectAcceptedTncByType = (type) =>
    createSelector(makeSelectConsumerAcceptedTnc(), (acceptedTnc) =>
        acceptedTnc ? acceptedTnc.find((item) => item.screenId === type) : {}
    );

const makeSelectTncLegals = () =>
    createSelector(makeSelectConsumerTnc(), makeSelectConsumerAcceptedTnc(), (tnc, acceptedTnc) => {
        const legals = tnc?.length
            ? tnc
                  .map(({legals}) => {
                      return legals ? [...legals] : [];
                  })
                  .reduce((prev, next) => [...prev, ...next])
            : [];
        const acceptedLegals = acceptedTnc?.length
            ? acceptedTnc
                  .map(({legals}) => {
                      return legals ? [...legals] : [];
                  })
                  .reduce((prev, next) => [...prev, ...next])
            : [];

        return [...legals, ...acceptedLegals];
    });

export {
    makeSelectAcceptedTncByType,
    makeSelectAggregatedSettings,
    makeSelectConsumerAcceptedTnc,
    makeSelectConsumerData,
    makeSelectConsumerProduct,
    makeSelectConsumerProducts,
    makeSelectConsumerTnc,
    makeSelectIotDeviceFullData,
    makeSelectTncByType,
    makeSelectTncLegals,
    selectDeviceNameKey,
};
